// extracted by mini-css-extract-plugin
export var card = "_41-0";
export var content = "_41-1";
export var contentLoading = "_41-2";